import { render, staticRenderFns } from "./task.vue?vue&type=template&id=ea6f998c&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "./task.vue?vue&type=style&index=0&id=ea6f998c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6f998c",
  null
  
)

export default component.exports